import { tokenize } from '@tonaljs/chord';
import { transpose, interval, distance } from '@tonaljs/core';
import { get } from '@tonaljs/roman-numeral';

/**
 * Given a tonic and a chord list expressed with roman numeral notation
 * returns the progression expressed with leadsheet chords symbols notation
 * @example
 * fromRomanNumerals("C", ["I", "IIm7", "V7"]);
 * // => ["C", "Dm7", "G7"]
 */
function fromRomanNumerals(tonic, chords) {
    const romanNumerals = chords.map(get);
    return romanNumerals.map((rn) => transpose(tonic, interval(rn)) + rn.chordType);
}
/**
 * Given a tonic and a chord list with leadsheet symbols notation,
 * return the chord list with roman numeral notation
 * @example
 * toRomanNumerals("C", ["CMaj7", "Dm7", "G7"]);
 * // => ["IMaj7", "IIm7", "V7"]
 */
function toRomanNumerals(tonic, chords) {
    return chords.map((chord) => {
        const [note, chordType] = tokenize(chord);
        const intervalName = distance(tonic, note);
        const roman = get(interval(intervalName));
        return roman.name + chordType;
    });
}
var index = { fromRomanNumerals, toRomanNumerals };

export { index as default, fromRomanNumerals, toRomanNumerals };
//# sourceMappingURL=index.es.js.map
